import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Facture } from '../../models/facture';
import { RestService } from "../rest.service";
import { Configuration } from '../../app.constants';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class FactureService extends RestService {

    constructor(_http: HttpClient, _configuration: Configuration) {
        super(_http,_configuration);
        this.modelName = 'facture';
        this.modelClass = Facture;
    }

    public getRealiseParUser(id: number): Observable<Facture[]>{
      return super.count("filter=realise_par_user_id,eq,"+id);
    }

}
